/* eslint-disable no-plusplus */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Container } from 'react-bootstrap';

import api from '../../services/api';

import Loading from '../../components/Loading';
import { TIPO_USUARIO } from '../../utils/funcoes';

import { useAuth } from '../../hooks/auth';

const Configuracao: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get('sessions/logado');
        console.log(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    loadDados();
  }, []);

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.ATENDENTE_CAIXA) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  // const handleNotification = (): void => {
  //   if (Notification?.permission === 'granted') {
  //     console.log(
  //       `The site has permission to show notifications. Showing notifications.\n`,
  //     );
  //     // If the user agreed to get notified
  //     // Let's try to send ten notifications
  //     let i = 0;
  //     // Using an interval cause some browsers (including Firefox) are blocking notifications if there are too much in a certain time.
  //     const interval = setInterval(() => {
  //       // Thanks to the tag, we should only see the "Hi no 9 from MDN." notification
  //       console.log('notificação');
  //       const n = new Notification(`Hi no ${i} from MDN.`, {
  //         tag: 'soManyNotification',
  //       });
  //       if (i === 9) {
  //         clearInterval(interval);
  //       }
  //       i++;
  //     }, 10000);
  //   } else if (Notification?.permission !== 'denied') {
  //     console.log('Requesting notification permission.\n');
  //     // If the user hasn't told if they want to be notified or not
  //     // Note: because of Chrome, we are not sure the permission property
  //     // is set, therefore it's unsafe to check for the "default" value.
  //     Notification.requestPermission().then(status => {
  //       // If the user said okay
  //       if (status === 'granted') {
  //         console.log('User granted the permission. Sending notifications.\n');
  //         let i = 0;
  //         // Using an interval cause some browsers (including Firefox) are blocking notifications if there are too much in a certain time.
  //         const interval = setInterval(() => {
  //           // Thanks to the tag, we should only see the "Message no 9 from MDN." notification
  //           const n = new Notification(`Message no ${i} from MDN.`, {
  //             tag: 'soManyNotification',
  //           });
  //           if (i === 9) {
  //             clearInterval(interval);
  //           }
  //           i++;
  //         }, 5000);
  //       } else {
  //         // Otherwise, we can fallback to a regular modal alert
  //         console.log(`User denied the permission request.\n`);
  //       }
  //     });
  //   } else {
  //     // If the user refuses to get notified, we can fallback to a regular modal alert
  //     console.log(`The site does not have permission to show notifications.\n`);
  //   }
  // };

  return (
    <Container fluid className="mt-2">
      {loading && <Loading backgroundBlack={false} />}
      <div className="bg-white border p-2 mb-2" style={{ minHeight: '400px' }}>
        <h2>Configurações do Sistema</h2>
        <p className="my-4">
          Gerencie usuários, permissões, imprima relatórios e outros através do
          menu administrativo
        </p>
        {/* <button
          type="button"
          onClick={handleNotification}
          className="dropdown-item text-dark"
          style={{ fontSize: '1rem' }}
        >
          teste
        </button> */}
      </div>
    </Container>
  );
};

export default Configuracao;
